export const getCustomApiEndpoint = (): string | null => {
  if (typeof window === "undefined") return null;

  const urlParams = new URLSearchParams(window.location.search);
  const customEndpoint = urlParams.get("custom_api_endpoint");

  if (customEndpoint) {
    sessionStorage.setItem("custom_api_endpoint", customEndpoint);
    return customEndpoint;
  }

  return sessionStorage.getItem("custom_api_endpoint");
};
